import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// ==========================================
// PUBLIC
// ==========================================
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import Home from "./pages/Home";
import PartnerRegister from "./pages/PartnerRegister";
import TrainerRegister from "./pages/TrainerRegister";
import Login from "./pages/Login";
import JobS from "./pages/JobS";
import Freelance from "./pages/Freelance";
import FreelancePro from "./pages/FreelancePro";
import Trainers from "./pages/Trainers";
import Faculties from "./pages/Faculties";
import HomeTutors from "./pages/HomeTutors";
import Freelancers from "./pages/Freelance";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PartnerNetwork from "./pages/PartnerNetwork";
import Reports from "./Admin/Reports";
// ==========================================
// SECURITY
// ==========================================
import ProtectedRoute from "./services/ProtectedRoute";

// ==========================================
// ADMIN
// ==========================================
import AdminLayout from "./Admin/AdminLayout";
import Dashboard from "./Admin/Dashboard";
import TrainerList from "./Admin/TrainerDetails";
import PartnerLeads from "./Admin/PartnerLeads";
import EmployeeRegister from "./Admin/EmployeeRegister";
import EmployeeList from "./Admin/EmployeeList";
import PartnerList from "./Admin/PartnerList";
import RecuirmentRequests from "./Admin/RecruitmentRequests";
import AllJob from "./Admin/AllJob";
import JobApplications from "./Admin/Job/JobApplication";
import SubscriptionProducts from "./Admin/Subscription/SubscriptionProducts";
import SubscriptionPlans from "./Admin/Subscription/SubscriptionPlans";
import SubscriptionManagement from "./Admin/Subscription/SubscriptionManagement";
import AdminInvitations from "./pages/AdminInvitations";
import UserRoles from "./Admin/UserRoles";
import SkillCategories from "./Admin/SkillCategories";
import Interview from "./pages/Interview";
import RequestList from "./pages/RequestList";
import AdminJobMatches from "./Admin/AdminJobMatches";
import TrainingOpportunities from "./Admin/TrainingOpportunities";
import AdminPartnerNotifications from "./Admin/PartnerNotifications";
import AdminJobAlerts from "./Admin/AdminJobAlerts";
import TrainerWorking from "./pages/TrainerWorking";


// ==========================================
// PARTNER
// ==========================================
import PartnerLayout from "./Admin/Partner/PartnerLayout";
import PartnerDashboard from "./Admin/Partner/PartnerDashboard";
import PartnerProfile from "./Admin/Partner/PartnerProfile";
import PartnerVerification from "./Admin/Partner/PartnerVerification";
import CreateJob from "./Admin/Partner/CreateJob";
import Jobs from "./Admin/Partner/Myjobs";
import ApplicationJob from "./Admin/Partner/ApplicationJob";
import JobMatches from "./Admin/Partner/JobMatches";
import SearchTrainers from "./Admin/Partner/SearchTrainers";
import TrainerRequests from "./Admin/Partner/TrainerRequests";
import TrainingProjects from "./Admin/Partner/TrainingProjects";
import TrainingRequests from "./Admin/Partner/TrainingRequests";
import TrainingSchedule from "./Admin/Partner/TrainingsSchedule";
import PartnerPayments from "./Admin/Partner/PartnerPayments";
import PaymentHistory from "./Admin/Partner/PaymentHistory";
import PartnerNotifications from "./Admin/Partner/PartnerNotifications";
import JobAlerts from "./Admin/Partner/JobAlerts";
import PartnerHeader from "./component/PartnerHeader";
import PartnerFooter from "./component/PartnerFooter";
import SubscriptionPurchase from "./Admin/Partner/SubscriptionPurchases";
import SubscriptionPlan from "./Admin/Partner/SubscriptionPlans";
import SubscriptionCheckout from "./Admin/Subscription/SubscriptionCheckout";
import CompanyDetailspage from "./Admin/CompanyDetailspage";
import SubscriptionDetails from "./Admin/SubscriptionDetails";
// import HiredTrainers from "./Admin/Partner/HiredTrainers";

// Partner — freelancing
import FreelanceProjectPost from "./Admin/Freelance/FreelanceProjectPost";
import FreelanceProjects from "./Admin/Freelance/FreelanceProject";

// ==========================================
// TRAINER
// ==========================================
import TrainerDashboard from "./Admin/Trainer/TrainerDashboard";
import AvailableJobs from "./Admin/Trainer/AvailableJobs";
import MyApplication from "./Admin/Trainer/MyApplications";
import TrainerProfile from "./Admin/Trainer/TrainerProfile";
import TrainerNotifications from "./pages/TrainerNotifications";
import TrainerInterviews from "./Admin/Trainer/TrainerInterviews";
// ==========================================
// EMPLOYEE
// ==========================================
import EmployeeLayout from "./Admin/Employee/EmployeeLayout";
import EmployeeDashboard from "./Admin/Employee/EmployeeDashboard";


// ==========================================
// PAGE WRAPPERS  (one place to change a layout)
// ==========================================
const PublicPage = ({ children }) => (
    <>
        <Navbar />
        {children}
        <Footer />
    </>
);

const AdminPage = ({ children }) => (
    <ProtectedRoute>
        <AdminLayout>{children}</AdminLayout>
    </ProtectedRoute>
);

const PartnerPage = ({ children }) => (
    <ProtectedRoute>
        <PartnerLayout>{children}</PartnerLayout>
    </ProtectedRoute>
);

const EmployeePage = ({ children }) => (
    <ProtectedRoute>
        <EmployeeLayout>{children}</EmployeeLayout>
    </ProtectedRoute>
);


// Trainer pages use the public Navbar/Footer instead of a sidebar layout
const TrainerPage = ({ children, footer = true }) => (
    <ProtectedRoute>
        <Navbar />
        {children}
        {footer && <Footer />}
    </ProtectedRoute>
);


// ==========================================
// OLD URL  ->  NEW URL
// Keeps bookmarks, login redirects and sidebar links working
// while you update them to the new paths.
// ==========================================
const legacyRedirects = [
    // admin
    ["/dashboard", "/admin/dashboard"],
    ["/trainer-list", "/admin/trainer-list"],
    ["/partner-list", "/admin/partner-list"],
    ["/partner-leads", "/admin/partner-leads"],
    ["/employee-list", "/admin/employee-list"],
    ["/employee-register", "/admin/employee-register"],
    ["/All-Jobs", "/admin/all-jobs"],
    ["/job-applications", "/admin/job-applications"],
    // trainer
    ["/trainer-dashboard", "/trainer/dashboard"],
    ["/trainer/my-application", "/trainer/my-applications"],
    // partner
    ["/partner-dashboard", "/partner/dashboard"],
    // employee
    ["/employee-dashboard", "/employee/dashboard"],
];


function App() {
    return (
        <BrowserRouter>
            <Routes>

                {/* ================= PUBLIC ================= */}
                <Route path="/" element={<PublicPage><Home /></PublicPage>} />
                <Route path="/trainer-register" element={<PublicPage><TrainerRegister /></PublicPage>} />
                <Route path="/partner-register" element={<PublicPage><PartnerRegister /></PublicPage>} />
                <Route path="/login" element={<PublicPage><Login /></PublicPage>} />
                <Route path="/jobs" element={<PublicPage><JobS /></PublicPage>} />
                <Route path="/freelance" element={<PublicPage><Freelance /></PublicPage>} />
                <Route path="/freelance-Users" element={<PublicPage><FreelancePro /></PublicPage>} />
                <Route path="/trainers" element={<PublicPage><Trainers /></PublicPage>} />
                <Route path="/faculties" element={<PublicPage><Faculties /></PublicPage>} />
                <Route path="/home-tutors" element={<PublicPage><HomeTutors /></PublicPage>} />
                <Route path="/freelancers" element={<PublicPage><Freelancers /></PublicPage>} />
                <Route path="/about" element={<PublicPage><About /></PublicPage>} />
                <Route path="/contact" element={<PublicPage><Contact /></PublicPage>} />
                <Route path="/privacy-policy" element={<PublicPage><PrivacyPolicy /></PublicPage>} />
                <Route path="/partner-network" element={<PublicPage><PartnerNetwork /></PublicPage>} />

                {/* ================= ADMIN  (/admin/...) ================= */}
                <Route path="/admin/dashboard" element={<AdminPage><Dashboard /></AdminPage>} />
                <Route path="/admin/trainer-list" element={<AdminPage><TrainerList /></AdminPage>} />
                <Route path="/admin/partner-list" element={<AdminPage><PartnerList /></AdminPage>} />
                <Route path="/admin/partner-leads" element={<AdminPage><PartnerLeads /></AdminPage>} />
                <Route path="/admin/recruiter-requests" element={<AdminPage><RecuirmentRequests /></AdminPage>} />
                <Route path="/admin/employee-list" element={<AdminPage><EmployeeList /></AdminPage>} />
                <Route path="/admin/employee-register" element={<AdminPage><EmployeeRegister /></AdminPage>} />
                <Route path="/admin/all-jobs" element={<AdminPage><AllJob /></AdminPage>} />
                <Route
  path="/trainer-working"
  element={<AdminPage><TrainerWorking /></AdminPage>}
/>
                <Route
                    path="/job-alerts"
                    element={
                        <AdminPage>
                            <AdminJobAlerts />
                        </AdminPage>
                    }
                />
                <Route
                    path="/partner-notifications"
                    element={
                        <AdminPage>
                            <AdminPartnerNotifications />
                        </AdminPage>
                    }
                />
                <Route
                    path="/reports"
                    element={
                        <AdminPage>
                            <Reports />
                        </AdminPage>
                    }
                />
                <Route path="/admin/job-applications" element={<AdminPage><JobApplications /></AdminPage>} />
                <Route
                    path="/admin/company-details/:partnerId"
                    element={
                        <AdminPage>
                            <CompanyDetailspage />
                        </AdminPage>
                    }
                />
                <Route
                    path="/training-opportunities"
                    element={<TrainingOpportunities />}
                />
                <Route
                    path="/admin/job-matches"
                    element={
                        <AdminPage>
                            <AdminJobMatches />
                        </AdminPage>
                    }
                />
                <Route
                    path="/admin/subscription-details/:partnerId"
                    element={
                        <AdminPage>
                            <SubscriptionDetails />
                        </AdminPage>
                    }
                />
                <Route
                    path="partner-job-requests"
                    element={
                        <AdminLayout>
                            <AdminInvitations />
                        </AdminLayout>
                    }
                />
                <Route
                    path="/admin/categories-skills"
                    element={
                        <AdminPage>
                            <SkillCategories />
                        </AdminPage>
                    }
                />

                <Route
                    path="/admin/users-roles"
                    element={
                        <AdminPage>
                            <UserRoles />
                        </AdminPage>
                    }
                />
                <Route path="/interview" element={<AdminPage>
                    <Interview />
                </AdminPage>} />
                <Route
                    path="/admin/pending-requests"
                    element={
                        <AdminPage>
                            <RequestList type="pending" />
                        </AdminPage>
                    }
                />

                <Route
                    path="/admin/approved-requests"
                    element={
                        <AdminPage>
                            <RequestList type="approved" />
                        </AdminPage>
                    }
                />

                <Route
                    path="/admin/selected-requests"
                    element={
                        <AdminPage>
                            <RequestList type="selected" />
                        </AdminPage>
                    }
                />


                {/* Admin — subscriptions */}
                <Route path="/admin/subscription-products" element={<AdminPage><SubscriptionProducts /></AdminPage>} />
                <Route path="/admin/subscription-plans" element={<AdminPage><SubscriptionPlans mode="admin" /></AdminPage>} />
                <Route path="/admin/subscription-management" element={<AdminPage><SubscriptionManagement /></AdminPage>} />

                {/* ================= TRAINER  (/trainer/...) ================= */}
                <Route path="/trainer/dashboard" element={<TrainerPage><TrainerDashboard /></TrainerPage>} />
                <Route path="/trainer/available-jobs" element={<ProtectedRoute><AvailableJobs /></ProtectedRoute>} />
                <Route path="/trainer/my-applications" element={<TrainerPage><MyApplication /></TrainerPage>} />
                <Route path="/trainer/profile" element={<TrainerPage footer={false}><TrainerProfile /></TrainerPage>} />
                <Route
                    path="/trainer/interviews"
                    element={
                        <ProtectedRoute>
                            <TrainerInterviews />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/trainer/:trainerId"
                    element={
                        <TrainerPage footer={false}>
                            <TrainerProfile />
                        </TrainerPage>
                    }
                />
                <Route
                    path="/trainer/applications"
                    element={
                        <TrainerPage>
                            <MyApplication />
                        </TrainerPage>
                    }
                />
                {/* ================= PARTNER  (/partner/...) ================= */}
                <Route path="/partner/dashboard" element={<PartnerPage><PartnerDashboard /></PartnerPage>} />

                {/* Profile */}
                <Route path="/partner/partner-profile" element={<PartnerPage><PartnerProfile /></PartnerPage>} />
                <Route path="/partner/partner-verification" element={<PartnerPage><PartnerVerification /></PartnerPage>} />

                {/* Jobs */}
                <Route path="/partner/create-job" element={<PartnerPage><CreateJob /></PartnerPage>} />
                <Route path="/partner/partner-jobs" element={<PartnerPage><Jobs /></PartnerPage>} />
                <Route path="/partner/application-job" element={<PartnerPage><ApplicationJob /></PartnerPage>} />
                <Route path="/partner/job-matches" element={<PartnerPage><JobMatches /></PartnerPage>} />
                <Route path="/job-matches" element={<AdminPage><AdminJobMatches /></AdminPage>} />

                {/* Trainers */}
                <Route
                    path="/partner/search-trainers"
                    element={
                        <ProtectedRoute>
                            <PartnerHeader />
                            <SearchTrainers />
                            <PartnerFooter />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/trainer-notifications"
                    element={<TrainerNotifications />}
                />
                <Route path="/partner/trainer-recently" element={<PartnerPage><TrainerRequests /></PartnerPage>} />
                {/* <Route path="/partner/hired-trainers" element={<PartnerPage><HiredTrainers /></PartnerPage>} /> */}

                {/* Training */}
                <Route path="/partner/training-projects" element={<PartnerPage><TrainingProjects /></PartnerPage>} />
                <Route path="/partner/training-requests" element={<PartnerPage><TrainingRequests /></PartnerPage>} />
                <Route path="/partner/training-schedule" element={<PartnerPage><TrainingSchedule /></PartnerPage>} />

                {/* Payments */}
                <Route path="/partner/partner-payments" element={<PartnerPage><PartnerPayments /></PartnerPage>} />
                <Route path="/partner/payment-history" element={<PartnerPage><PaymentHistory /></PartnerPage>} />

                {/* Notifications */}
                <Route path="/partner/partner-notifications" element={<PartnerPage><PartnerNotifications /></PartnerPage>} />
                <Route path="/partner/job-alerts" element={<PartnerPage><JobAlerts /></PartnerPage>} />

                {/* Freelancing */}
                <Route path="/partner/freelance-job" element={<ProtectedRoute><FreelanceProjectPost /></ProtectedRoute>} />
                <Route path="/partner/freelance-project" element={<ProtectedRoute><FreelanceProjects /></ProtectedRoute>} />

                {/* Subscription */}
                <Route path="/partner/subscription" element={<PartnerPage><SubscriptionPurchase /></PartnerPage>} />
                <Route path="/partner/subscription-plans" element={<PartnerPage><SubscriptionPlan /></PartnerPage>} />
                <Route
                    path="/partner/subscriptions/checkout/:planId"
                    element={<SubscriptionCheckout />}
                />
                {/* ================= EMPLOYEE  (/employee/...) ================= */}
                <Route path="/employee/dashboard" element={<EmployeePage><EmployeeDashboard /></EmployeePage>} />


                {/* ================= OLD URLS -> NEW URLS ================= */}
                {legacyRedirects.map(([from, to]) => (
                    <Route key={from} path={from} element={<Navigate to={to} replace />} />
                ))}

            </Routes>
        </BrowserRouter>
    );
}

export default App;